import { render, staticRenderFns } from "./create-or-edit-module.vue?vue&type=template&id=6d9ba47e&scoped=true"
import script from "./create-or-edit-module.vue?vue&type=script&lang=js"
export * from "./create-or-edit-module.vue?vue&type=script&lang=js"
import style0 from "./create-or-edit-module.vue?vue&type=style&index=0&id=6d9ba47e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9ba47e",
  null
  
)

export default component.exports